import { useContext } from 'react';

import { WorkspacesContext, WorkspacesContextType } from './WorkspacesProvider';

export default function useWorkspacesContext(): WorkspacesContextType;
export default function useWorkspacesContext(options: { requireWorkspaceId: false }): WorkspacesContextType;
export default function useWorkspacesContext(options: { requireWorkspaceId: true }): WorkspacesContextType & {
  workspaceId: string;
};

export default function useWorkspacesContext(options?: { requireWorkspaceId?: boolean }): WorkspacesContextType {
  const context = useContext(WorkspacesContext);
  if (!context) throw new Error('useWorkspacesContext must be used within a WorkspacesProvider');

  const isWorkspaceIdRequired = options?.requireWorkspaceId ?? false;

  if (isWorkspaceIdRequired) {
    if (!context.workspaceId) {
      throw new Error('Workspace ID not set. If this is intentional, pass option requireWorkspaceId: false.');
    }

    return context as WorkspacesContextType & { workspaceId: string };
  }

  return context as WorkspacesContextType;
}
